import { render, staticRenderFns } from "./InviteJoin2.vue?vue&type=template&id=1fd995e0&scoped=true"
import script from "./InviteJoin2.vue?vue&type=script&lang=js"
export * from "./InviteJoin2.vue?vue&type=script&lang=js"
import style0 from "./InviteJoin2.vue?vue&type=style&index=0&id=1fd995e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd995e0",
  null
  
)

export default component.exports